import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import { createUseStyles } from 'react-jss';
import Cursor from '../../../images/icons/cursor.png';
import { Collapse } from 'react-collapse';
import { styles } from '../../AuctionForm/formStyles';
import icons from '../../../helpers/Icons';

const DetailsCategory = ({ icon, categoryName, description, iconColor, }) => {
  const classes = useStyles({ iconColor, });
  const [open, setOpen] = useState(false);
  return (
    <>
      { Boolean(description) &&
        <div className={classes.catogory}>
          <div
            role="button"
            className={classes.categoryHeader}
            onClick={() => setOpen(!open)}
            tabIndex={0}
          >
            {icons(icon)}
            <div className={classes.categoryTitle}>
              {categoryName}
            </div>
            <div
              className={classes.arrow}
              style={{ transform: open ? 'rotate(180deg)' : 'none', }}
            >
              {icons('arrow_drop_desc')}
            </div>
          </div>
          <Collapse isOpened={open}>
            <div className={classes.categoryDescription}>
              { Array.isArray(description)
                ? (
                  <ul>
                    {description.map((item) => (
                      <li key={get(item, 'id')}> {get(item, 'body')} </li>
                    ))}
                  </ul>
                ) : (
                  <div>
                    {description}
                  </div>
                )
              }

            </div>
          </Collapse>
        </div>
      }
    </>
  );
};

DetailsCategory.propTypes = {
  icon: PropTypes.string.isRequired,
  categoryName: PropTypes.string.isRequired,
  description: PropTypes.oneOfType([PropTypes.object, PropTypes.string, PropTypes.array]),
  iconColor: PropTypes.string,
};

DetailsCategory.defaultProps = {
  iconColor: '#8A8695',
  description: '',
};


const useStyles = createUseStyles({
  catogory: {
    borderBottom: '1px solid #E5E3E8',
  },
  categoryHeader: (props) => ({
    color: styles.colors.darkGray,
    fontSize: '16px',
    fontWeight: 'bold',
    display: 'flex',
    width: '100%',
    justifyContent: 'space-between',
    height: '59px',
    alignItems: 'center',
    cursor: `url(${Cursor}), auto`,
    '& i': {
      position: 'relative',
      margin: '0em 0.5em',
      color: props.iconColor,
    },
    '&:hover': {
      backgroundColor: styles.colors.lightGray,
      borderTop: '1px solid #E5E3E8',
    },
  }),
  arrow: {
    '& i': {
      color: 'black !important',
    },
  },
  categoryTitle: {
    paddingLeft: '1em',
    width: '90%',
  },
  categoryDescription: {
    fontSize: '16px',
    padding: '1em 0em',
    fontWeight: '400',
    color: styles.colors.darkGray,
    '& li': {
      marginLeft: '1em',
    },
  },
  '@media (max-width: 900px)': {
    categoryHeader: {
      fontSize: '13px !important',
      height: '45px !important',
    },
  },
});

export default DetailsCategory;

